import { Navigate, Outlet, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ROUTES } from "../../config";
import { Skeleton } from "../ui/Skeleton/Skeleton";

export const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const { lang } = useParams<{ lang: string }>();

  if (isLoading) {
    return (
      <div style={{ padding: "2rem" }}>
        <Skeleton height="60px" style={{ marginBottom: "2rem" }} />
        <Skeleton height="300px" style={{ borderRadius: "12px" }} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${lang || "en"}${ROUTES.LOGIN}`} replace />;
  }

  return <Outlet />;
};
